import { recaptchaInit } from "../js/recaptcha.js";

$(() => {
    $("#time-to-call").niceSelect();

    $("#time-to-call-sidebar").niceSelect();

    $(
        "form#second-opinion-header #second-opinion-header-file, form#second-opinion-sidebar #second-opinion-sidebar-file, form#second-opinion #second-opinion-sidebar-file"
    ).on("change", event => {
        event.stopPropagation();
        let f = event.target.files[0];
        if (f.size >= 5 * 1024 * 1024) {
            Toast.fire({
                icon: "warning",
                title: "Only upload file of maximum 5MB!"
            });
            event.target.value = null;
            $(event.target)
                .siblings("[data-file-input-value]")
                .empty()
                .text("Browse PDF,JPG,DOC...");
            event.preventDefault();
            return false;
        }
        if (!f.type.match(
                "(image/jp.*|application/pdf|application/doc.*|image/pn.*|application/vnd.openxmlformats-officedocument.wordprocessingml.document)"
            )) {
            if (window.hasOwnProperty("Toast")) {
                Toast.fire({
                    icon: "warning",
                    title: "We Support PDF, DOC, JPG & PNG!"
                });
            }
            event.target.value = null;
            $(event.target)
                .siblings("[data-file-input-value]")
                .empty()
                .text("Browse PDF,JPG,DOC...");
            event.preventDefault();
            return false;
        }

        let fl = new FileReader();
        fl.onload = e => {
            let bs = new Uint8Array(e.target.result);
            let i =
                bs.length > 4 &&
                bs[0] == 0xff &&
                bs[1] == 0xd8 &&
                bs[2] == 0xff &&
                bs[3] == 0xe0;
            let x =
                bs.length > 4 &&
                bs[0] == 0x50 &&
                bs[1] == 0x4b &&
                bs[2] == 0x03 &&
                bs[3] == 0x04;
            let dx =
                bs.length > 4 &&
                bs[0] == 0x50 &&
                bs[1] == 0x4b &&
                bs[2] == 0x05 &&
                bs[3] == 0x06;
            let dcx =
                bs.length > 4 &&
                bs[0] == 0x50 &&
                bs[1] == 0x4b &&
                bs[2] == 0x07 &&
                bs[3] == 0x08;
            let p =
                bs.length > 5 &&
                bs[0] == 0x25 &&
                bs[1] == 0x50 &&
                bs[2] == 0x44 &&
                bs[3] == 0x46 &&
                bs[4] == 0x2d;
            let d =
                bs.length > 8 &&
                bs[0] == 0xd0 &&
                bs[1] == 0xcf &&
                bs[2] == 0x11 &&
                bs[3] == 0xe0 &&
                bs[4] == 0xa1 &&
                bs[5] == 0xb1 &&
                bs[6] == 0x1a &&
                bs[7] == 0xe1;
            let g =
                bs.length > 8 &&
                bs[0] == 0x89 &&
                bs[1] == 0x50 &&
                bs[2] == 0x4e &&
                bs[3] == 0x47 &&
                bs[4] == 0x0d &&
                bs[5] == 0x0a &&
                bs[6] == 0x1a &&
                bs[7] == 0x0a;
            if (i || p || d || g || x || dx || dcx) {} else {
                if (window.hasOwnProperty("Toast")) {
                    Toast.fire({
                        icon: "warning",
                        title: "We Support PDF, DOC, JPG & PNG!"
                    });
                }
                event.target.value = null;
                $(event.target)
                    .siblings("[data-file-input-value]")
                    .empty()
                    .text("Browse PDF,JPG,DOC...");
                event.preventDefault();
                return false;
            }
        };
        fl.readAsArrayBuffer(f);
        console.log("file uploadeeddd");
    });

    $("input[data-press-name]").on("keypress", function(e) {
        if (!/^[A-Za-z\s]$/.test(e.key)) e.preventDefault();
    });
    $("input[data-press-email]").on("keypress", function(e) {
        if (e.target.value.length > 4) {
            e.target.classList.contains("is-invalid") ?
                e.target.classList.remove("is-invalid") :
                "";
        }
        if (!/^[a-z0-9._%+-@]$/.test(e.key)) e.preventDefault();
    });
    $("input[data-press-phone]").on("keypress", function(e) {
        if (!/^[0-9]$/.test(e.key)) e.preventDefault();
        const inp = e.currentTarget;
        if (inp.getAttribute("dial") === "+91") {
            if (e.target.value.length === 10) {
                e.target.classList.contains("is-invalid") ?
                    e.target.classList.remove("is-invalid") :
                    "";
            }
            if (e.target.value.length > 9) e.preventDefault();
        } else {
            if (e.target.value.length >= 10 && e.target.value.length <= 14) {
                e.target.classList.contains("is-invalid") ?
                    e.target.classList.remove("is-invalid") :
                    "";
            }

            if (e.target.value.length > 13) e.preventDefault();
        }
    });

    const teleDial = document.querySelectorAll("input[tele-dial]");

    teleDial.forEach(td => {
        const intlp = intlTelInput(td, {
            initialCountry: "IN",
            separateDialCode: true
        });
        td.setAttribute("dial", `+${intlp.getSelectedCountryData().dialCode}`);

        td.addEventListener("countrychange", function(e) {
            td.setAttribute(
                "dial",
                `+${intlp.getSelectedCountryData().dialCode}`
            );
            if (td.getAttribute("dial") === "+91") {
                if (td.value.length >= 10) {
                    td.value = td.value.substring(0, 10);
                }
            }
        });
    });

    String.prototype.toSnake = function() {
        return this.match(
                /[A-Z]{3,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g
            )
            .map(s => s.toLowerCase())
            .join("_");
    };

    const resetForm = (form, dataPressPhone) => {
        if (dataPressPhone.hasAttribute("dial")) {
            dataPressPhone.value = dataPressPhone.value
                .trim()
                .replace(dataPressPhone.getAttribute("dial").trim(), "");
        }

        form.querySelectorAll("[name],button").forEach(
            p => (p.readOnly = !p.readOnly)
        );

        form.querySelectorAll("[name],button").forEach(
            p => (p.disabled = !p.disabled)
        );
    };

    const showSecondOpinionSidebarErrors = errors => {
        const errorsTargetEl = $("#second-opinion-sidebar-alerts");

        Object.keys(errors).forEach(ix => {
            const entry = errors[ix][0];

            errorsTargetEl.append(`

                            <div class="alert-card">
                                <div class="alert warning-alert">
                                    <i class="info fa fa-exclamation-circle"></i>
                                    <h3>${entry}</h3>
                                    <i class="close fa fa-times"
                                        onclick="((e) => {e.parentElement.parentElement.style.opacity = 0;setTimeout(() => {e.parentElement.parentElement.remove();}, 250);})(this);"></i>
                                </div>
                            </div>
                        `);
        });
    };

    const internationalFormErrors = errors => {
        const errorsTargetEl = $("#international-form-alerts");

        Object.keys(errors).forEach(ix => {
            const entry = errors[ix][0];

            errorsTargetEl.append(`

                            <div class="alert-card">
                                <div class="alert warning-alert">
                                    <i class="info fa fa-exclamation-circle"></i>
                                    <h3>${entry}</h3>
                                    <i class="close fa fa-times"
                                        onclick="((e) => {e.parentElement.parentElement.style.opacity = 0;setTimeout(() => {e.parentElement.parentElement.remove();}, 250);})(this);"></i>
                                </div>
                            </div>
                        `);
        });
    };

    const showSecondOpinionHeaderErrors = errors => {
        const firstError = Object.hasOwnProperty(Object.keys(errors)[0]) ?
            errors[Object.keys(errors)[0]][0] :
            null;

        if (firstError) {
            Toast.fire({
                icon: "warning",
                title: firstError
            });
        }
    };

    const handleSecondOpinionSubmission = async(e, showErrors) => {
        grecaptcha.ready(async() => {
            let form = e.target.closest("form");
            const eventName = form.getAttribute("id").toSnake();
            let dataPressPhone = form.querySelector("input[data-press-phone]");
            let dataPressEmail = form.querySelector("input[data-press-email]");
            let dataTimeToCall = form.querySelector(
                'select[name="time-to-call"]'
            );

            if (dataPressEmail) {
                if (!(dataPressEmail.value.length > 0)) {
                    Toast.fire({
                        icon: "warning",
                        title: "Please provide a valid email!"
                    });
                    dataPressEmail.focus();
                    dataPressEmail.classList.add("is-invalid");
                    return false;
                }
            }
            if (
                dataPressPhone.value.length < 10 ||
                dataPressPhone.value.length > 14
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid number!"
                });
                dataPressPhone.focus();
                dataPressPhone.classList.add("is-invalid");
                return false;
            }

            if (!(dataTimeToCall.value.length > 0)) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a preferred time to talk!"
                });
                dataTimeToCall.classList.add("is-invalid");
                return false;
            }

            if (form.checkValidity()) {
                form.querySelectorAll("[name],button").forEach(
                    p => (p.readOnly = !p.readOnly)
                );

                if (dataPressPhone.hasAttribute("dial")) {
                    dataPressPhone.value =
                        dataPressPhone.getAttribute("dial").trim() +
                        dataPressPhone.value.trim();
                }

                let fd = new FormData(form);


                let fileObject = fd.get('file');

                let fileName = fileObject.name;


                const recaptcha = await recaptchaInit(eventName);

                fd.append("recaptcha", recaptcha);

                dataLayer.push({
                    'event': 'get_second_opinion_header'
                });

                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    }
                });

                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {
                        if (response.status == "success") {
                            $(form).html(
                                "<div class='second-opinion-submitted'>" +
                                " Second opinion is not a physical/video consultation, our health specialists will study your reports and will get back to you for further details." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )

                                .remove();
                            }


                            // if (fileName != '') {
                            //     dataLayer.push({
                            //         'event': 'Mhc_header_gaso_form_upload'
                            //     });
                            // }

                            // dataLayer.push({
                            //     'event': 'Mhc_header_gaso_form_submit'
                            // });



                        } else if (response.status === "error") {
                            showErrors(response.errors);

                            resetForm(form, dataPressPhone);
                        } else {
                            $(form).append(
                                "<div class='color-white text-center f-18'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )

                                .remove();
                            }

                            console.error(response);
                        }
                    })
                    .fail(function(error) {
                        console.error("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.readOnly = !p.readOnly)
                        );
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {
                let tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    };

    const handleSecondOpinionSidebarSubmission = async(e, showErrors) => {
        grecaptcha.ready(async() => {
            let form = e.target.closest("form");
            const eventName = form.getAttribute("id").toSnake();
            let dataPressPhone = form.querySelector("input[data-press-phone]");

            if (
                dataPressPhone.value.length < 10 ||
                dataPressPhone.value.length > 14
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid number!"
                });
                dataPressPhone.focus();
                dataPressPhone.classList.add("is-invalid");
                return false;
            }

            if (form.checkValidity()) {
                form.querySelectorAll("[name],button").forEach(
                    p => (p.readOnly = !p.readOnly)
                );

                if (dataPressPhone.hasAttribute("dial")) {
                    dataPressPhone.value =
                        dataPressPhone.getAttribute("dial").trim() +
                        dataPressPhone.value.trim();
                }

                let fd = new FormData(form);

                let fileObject = fd.get('file');
                let fileName = fileObject.name;

                let entityName = fd.get('entity_name').toLowerCase().split(' ').join('_');
                let entitytype = fd.get('entity_type');



                // if (fileName != '') {
                //     dataLayer.push({
                //         'event': 'Mhc_gaso_form_upload',
                //         'Mhc_var_gaso_form_upload': entitytype + '_' + entityName
                //     });
                // }

                dataLayer.push({
                    'event': 'get_second_opinion_side_bar',
                });

                const recaptcha = await recaptchaInit(eventName);

                fd.append("recaptcha", recaptcha);

                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    }
                });

                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {
                        if (response.status == "success") {
                            $(form).html(
                                "<div class='second-opinion-submitted'>" +
                                " Second opinion is not a physical/video consultation, our health specialists will study your reports and will get back to you for further details." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )

                                .remove();
                            }
                        } else if (response.status === "error") {
                            showErrors(response.errors);

                            resetForm(form, dataPressPhone);
                        } else {
                            $(form).append(
                                "<div class='color-white text-center f-18'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )

                                .remove();
                            }

                            console.error(response);
                        }
                    })
                    .fail(function(error) {
                        console.error("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.readOnly = !p.readOnly)
                        );
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {
                let tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    };

    const internationalFormSubmission = async(e, showErrors) => {
        grecaptcha.ready(async() => {
            let form = e.target.closest("form");
            const eventName = form.getAttribute("id").toSnake();
            let dataPressPhone = form.querySelector("input[data-press-phone]");
            let dataPressName = form.querySelector("input[data-press-name]");
            let dataPressEmail = form.querySelector("input[data-press-email]");

            if (
                dataPressName.value.length < 2
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid name!"
                });
                dataPressName.focus();
                dataPressName.classList.add("is-invalid");
                return false;
            } else {
                dataPressName.classList.remove("is-invalid");
            }



            if (
                dataPressPhone.value.length < 8 ||
                dataPressPhone.value.length > 14
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid number!"
                });
                dataPressPhone.focus();
                dataPressPhone.classList.add("is-invalid");
                return false;
            } else {
                dataPressPhone.classList.remove("is-invalid");
            }


            if (form.checkValidity()) {
                form.querySelectorAll("[name],button").forEach(
                    p => (p.readOnly = !p.readOnly)
                );

                if (dataPressPhone.hasAttribute("dial")) {
                    dataPressPhone.value =
                        dataPressPhone.getAttribute("dial").trim() +
                        dataPressPhone.value.trim();
                }

                let fd = new FormData(form);

                const recaptcha = await recaptchaInit(eventName);

                fd.append("recaptcha", recaptcha);

                dataLayer.push({
                    'event': 'international_patient_book',
                });

                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );
                $.ajaxSetup({
                    headers: {
                        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
                    }
                });

                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {
                        if (response.status == "success") {
                            $(form).html(
                                "<div class='second-opinion-submitted color-blue pl-lg-4'>" +
                                " Thank you for submitting your details. One of our health experts will reach out to you shortly." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "international-title"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "international-title"
                                )

                                .innerHTML = "";
                            }
                        } else if (response.status === "error") {
                            showErrors(response.errors);

                            resetForm(form, dataPressPhone);
                        } else {
                            $(form).append(
                                "<div class='color-white text-center f-18'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )

                                .remove();
                            }

                            console.error(response);
                        }
                    })
                    .fail(function(error) {
                        console.error("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.readOnly = !p.readOnly)
                        );
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {
                let tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    };

    const handleSecondOpinionBlogSidebarSubmission = async(e, showErrors) => {
        grecaptcha.ready(async() => {
            let form = e.target.closest("form");
            const eventName = form.getAttribute("id").toSnake();
            let dataPressPhone = form.querySelector("input[data-press-phone]");

            if (
                dataPressPhone.value.length < 10 ||
                dataPressPhone.value.length > 14
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid number!"
                });
                dataPressPhone.focus();
                dataPressPhone.classList.add("is-invalid");
                return false;
            }

            if (form.checkValidity()) {
                form.querySelectorAll("[name],button").forEach(
                    p => (p.readOnly = !p.readOnly)
                );

                if (dataPressPhone.hasAttribute("dial")) {
                    dataPressPhone.value =
                        dataPressPhone.getAttribute("dial").trim() +
                        dataPressPhone.value.trim();
                }

                let fd = new FormData(form);

                const recaptcha = await recaptchaInit(eventName);

                fd.append("recaptcha", recaptcha);

                dataLayer.push({
                    'event': 'get_a_call_back',
                });

                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    }
                });

                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {
                        if (response.status == "success") {
                            $(form).html(
                                "<div class='second-opinion-submitted'>" +
                                " Thank you for submitting your details. One of our health experts will reach out to you shortly." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )

                                .remove();
                            }
                        } else if (response.status === "error") {
                            showErrors(response.errors);

                            resetForm(form, dataPressPhone);
                        } else {
                            $(form).append(
                                "<div class='color-white text-center f-18'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                            if (
                                document.getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )
                            ) {
                                document

                                    .getElementById(
                                    "second-opinion-sidebar-subtitle"
                                )

                                .remove();
                            }

                            console.error(response);
                        }
                    })
                    .fail(function(error) {
                        console.error("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.readOnly = !p.readOnly)
                        );
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {
                let tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    };

    $("button#submitOpinionForm").on("click", async function(event) {
        event.preventDefault();

        await handleSecondOpinionSubmission(
            event,
            showSecondOpinionHeaderErrors
        );
    });

    $("button#subscribe-btn").on("click", async function(e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        grecaptcha.ready(async() => {
            let form = e.target.closest("form#subscribe-newsletter");
            const eventName = form.getAttribute("id").toSnake();
            if (form.checkValidity()) {
                let fd = new FormData(form);

                const recaptcha = await recaptchaInit(eventName);

                fd.append("recaptcha", recaptcha);



                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );

                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    }
                });
                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {
                        if (response.status == "success") {
                            $(form).html(
                                "<div class='color-white text-center text-info font-weight-bold f-18'>" +
                                "Thank you for subscribing to Nanavati Max Hospital newsletter." +
                                "</div>"
                            );

                            // dataLayer.push({
                            //     'event': 'Mhc_email_subscribe_form'
                            // });

                        } else {
                            console.error(response);

                            $(form).append(
                                "<div class='color-white text-center text-info f-18 font-weight-bold'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                        }
                    })
                    .fail(function(error) {
                        console.log("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {
                let tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    });

    $("button#submitOpinionFormSidebar").on("click", async function(event) {
        event.preventDefault();

        await handleSecondOpinionSidebarSubmission(
            event,
            showSecondOpinionSidebarErrors
        );
    });

    $("button#submitOpinionBlogFormSidebar").on("click", async function(event) {
        event.preventDefault();

        await handleSecondOpinionBlogSidebarSubmission(
            event,
            showSecondOpinionSidebarErrors
        );
    });

    $("button#internationalSubmit").on("click", async function(event) {
        event.preventDefault();

        await internationalFormSubmission(
            event,
            internationalFormErrors
        );
    });

    $("button#internationalEnquirySubmit").on("click", async function(event) {
        event.preventDefault();

        await internationalFormSubmission(
            event,
            internationalFormErrors
        );
    });


    $("button.unitFormSubmission").on("click", async function(event) {
        event.preventDefault();

        grecaptcha.ready(async() => {
                let form = event.target.closest("form");
                const eventName = form.getAttribute("id").toSnake();
                let dataPressPhone = form.querySelector("input[data-press-phone]");
                let dataPressName = form.querySelector("input[data-press-name]");
                //let dataPressEmail = form.querySelector("input[data-press-email]");
                let entity_type = form.querySelector("input[entity-type]");



                if (
                    dataPressPhone.value.length < 10 ||
                    dataPressPhone.value.length > 14
                ) {
                    Toast.fire({
                        icon: "warning",
                        title: "Please provide a valid number!"
                    });
                    dataPressPhone.focus();
                    dataPressPhone.classList.add("is-invalid");
                    return false;
                } else {
                    dataPressPhone.classList.contains("is-invalid") ?
                        dataPressPhone.classList.remove("is-invalid") :
                        "";
                }



                if (
                    dataPressName.value.length < 2
                ) {
                    Toast.fire({
                        icon: "warning",
                        title: "Please provide a valid name!"
                    });
                    dataPressName.focus();
                    dataPressName.classList.add("is-invalid");
                    return false;
                } else {
                    dataPressName.classList.remove("is-invalid");
                }


                /*
                                if (!(dataPressEmail.value.length > 0)) {
                                    Toast.fire({
                                        icon: "warning",
                                        title: "Please provide a valid email!"
                                    });
                                    try {
                                        dataPressEmail.focus();
                                    } catch (e) {}
                                    dataPressEmail.classList.add("is-invalid");
                                    return false;
                                } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dataPressEmail.value)) {

                                    let checkOut = !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(dataPressEmail.value);
                                    console.log("chekcouttttt", checkOut);
                                    Toast.fire({
                                        icon: "warning",
                                        title: "Please provide a valid email!"
                                    });
                                    dataPressEmail.focus();
                                    dataPressEmail.classList.add("is-invalid");
                                    return false;
                                } else {
                                    dataPressEmail.classList.remove("is-invalid");
                                }

                */



                if (form.checkValidity()) {

                    form.querySelectorAll("[name],button").forEach(
                        p => (p.readOnly = !p.readOnly)
                    );

                    if (dataPressPhone.hasAttribute("dial")) {
                        dataPressPhone.value =
                            dataPressPhone.getAttribute("dial").trim() +
                            dataPressPhone.value.trim();
                    }



                    // if (entity_type.value == 'Doctor Second Opinion') {
                    //     dataLayer.push({
                    //         'event': 'cps_so_form_banner_racb'
                    //     });
                    // }

                    // if (entity_type.value == 'Doctor Unit Page') {
                    //     dataLayer.push({
                    //         'event': 'cps_hos_form_banner_racb'
                    //     });

                    // }




                    let fd = new FormData(form);

                    const recaptcha = await recaptchaInit(eventName);

                    fd.append("recaptcha", recaptcha);

                    form.querySelectorAll("[name],button").forEach(
                        p => (p.disabled = !p.disabled)
                    );

                    $.ajaxSetup({
                        headers: {
                            "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                                "content"
                            )
                        }
                    });

                    $.ajax({
                            url: form.getAttribute("action"),
                            type: "post",
                            data: fd,
                            cache: false,
                            contentType: false,
                            processData: false
                        })
                        .done(function(response) {

                            if (response.status == "success") {
                                $(form).html(
                                    "<div class='second-opinion-submitted pb-1 text-white'>" +
                                    " Thank you for submitting your details. One of our health experts will reach out to you shortly." +
                                    "</div>"
                                );
                                $(form).prev().hide();

                            } else if (response.status === "error") {
                                showErrors(response.errors);

                                resetForm(form, dataPressPhone);
                            } else {
                                $(form).append(
                                    "<div class='color-white text-center f-18'>" +
                                    "Submission failed. Please try after sometime." +
                                    "</div>"
                                );
                                $(form).prev().hide();

                                console.error(response);
                            }
                        })
                        .fail(function(error) {
                            console.error("error", error);
                            form.querySelectorAll("[name],button").forEach(
                                p => (p.readOnly = !p.readOnly)
                            );
                            form.querySelectorAll("[name],button").forEach(
                                p => (p.disabled = !p.disabled)
                            );
                        });
                } else {

                    let tmpSubmit = document.createElement("button");
                    form.appendChild(tmpSubmit);
                    tmpSubmit.click();
                    form.removeChild(tmpSubmit);
                }
            }

        );
    });


    $("button.healthPackageSubmitBtn").on("click", async function(e) {
        e.preventDefault();

        grecaptcha.ready(async() => {
            let form = e.target.closest("form#healthPackageForm");
            let dataPressPhone = form.querySelector('input[name="mobile"]');
            let dataPressName = form.querySelector('input[name="name"]');

            if (!(dataPressName.value.length > 0)) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid email!"
                });
                dataPressName.focus();
                dataPressName.classList.add("is-invalid");
                return false;
            }

            if (
                dataPressPhone.value.length < 10 ||
                dataPressPhone.value.length > 14
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid number!"
                });
                dataPressPhone.focus();
                dataPressPhone.classList.add("is-invalid");
                return false;
            }

            if (form.checkValidity()) {
                form.querySelectorAll("[name],button").forEach(
                    p => (p.readOnly = !p.readOnly)
                );

                let fd = new FormData($("form#healthPackageForm").get(0));
                fd.append("submission-url", window.location.href);
                fd.append(
                    "_token",
                    form.querySelector("input[name='_token']").value
                );

                const recaptcha = await recaptchaInit("second_opinion");

                dataLayer.push({
                    'event': 'health_plan_book',
                });

                fd.append("recaptcha", recaptcha);

                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    }
                });
                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {
                        if (response.status == "success") {
                            $("form#healthPackageForm").html(
                                "<div class='second-opinion-page-submitted'>" +
                                "Thank you for the submission. We will get back to you soon." +
                                "</div>"
                            );

                        } else if (response.status === "error") {
                            const errors = response.errors;

                            const errorsTargetEl = $(
                                "#second-opinion-page-alerts"
                            );

                            Object.keys(errors).forEach(ix => {
                                const entry = errors[ix][0];

                                errorsTargetEl.append(`

                                    <div class="alert-card">
                                        <div class="alert warning-alert">
                                            <i class="info fa fa-exclamation-circle"></i>
                                            <h3>${entry}</h3>
                                            <i class="close fa fa-times"
                                                onclick="((e) => {e.parentElement.parentElement.style.opacity = 0;setTimeout(() => {e.parentElement.parentElement.remove();}, 250);})(this);"></i>
                                        </div>
                                    </div>
                                `);

                                if (dataPressPhone.hasAttribute("dial")) {
                                    dataPressPhone.value = dataPressPhone.value
                                        .trim()
                                        .replace(
                                            dataPressPhone
                                            .getAttribute("dial")
                                            .trim(),
                                            ""
                                        );
                                }

                                form.querySelectorAll("[name],button").forEach(
                                    p => (p.readOnly = !p.readOnly)
                                );

                                form.querySelectorAll("[name],button").forEach(
                                    p => (p.disabled = !p.disabled)
                                );
                            });
                        } else {
                            $("form#healthPackageForm").append(
                                "<div class='text-center f-18'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                        }
                    })
                    .fail(function(error) {
                        console.log("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {
                var tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    });


    $("button.requestCallbackFormSubmission").on("click", async function(event) {

        event.preventDefault();

        grecaptcha.ready(async() => {


            let form = event.target.closest("form");

            const eventName = form.getAttribute("id").toSnake();
            let dataPressPhone = form.querySelector("input[data-press-phone]");
            let dataPressName = form.querySelector("input[data-press-name]");
            let entity_type = form.querySelector("input[entity-type]");
            let full_url = form.querySelector("input[current-url]");



            if (
                dataPressName.value.length < 2
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid name!"
                });
                dataPressName.focus();
                dataPressName.classList.add("is-invalid");
                return false;
            } else {
                dataPressName.classList.remove("is-invalid");
            }


            if (
                dataPressPhone.value.length < 10 ||
                dataPressPhone.value.length > 14
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid number!"
                });
                dataPressPhone.focus();
                dataPressPhone.classList.add("is-invalid");
                return false;
            }




            if (form.checkValidity()) {

                form.querySelectorAll("[name],button").forEach(
                    p => (p.readOnly = !p.readOnly)
                );

                if (dataPressPhone.hasAttribute("dial")) {
                    dataPressPhone.value =
                        dataPressPhone.getAttribute("dial").trim() +
                        dataPressPhone.value.trim();
                }



                // if (entity_type.value == 'Doctor Second Opinion') {
                //     dataLayer.push({
                //         'event': 'cps_so_form_racb',
                //         'var_cps_so_form_racb': full_url.value
                //     });
                // }

                // if (entity_type.value == 'Doctor CPS Page') {
                //     dataLayer.push({
                //         'event': 'cps_dr_request_a_call_back',
                //         'var_cps_dr_request_a_call_back': full_url.value
                //     });
                // }

                // if (entity_type.value == 'Doctor Unit Page') {
                //     dataLayer.push({
                //         'event': 'cps_hos_form_racb',
                //         'var_cps_hos_form_racb': full_url.value
                //     });
                // }


                // if (entity_type.value == 'Doctor Speciality Page') {

                //     dataLayer.push({
                //         'event': 'sil_request_a_call_back',
                //         'var_sil_request_a_call_back': full_url.value
                //     });
                // }

                // if (entity_type.value == 'Find a Doctor') {
                //     console.log("full url", full_url);

                //     dataLayer.push({
                //         'event': 'fad_request_a_call_back',
                //         'var_fad_request_a_call_back': full_url.value
                //     });
                // }

                dataLayer.push({
                    'event': 'request_call_back'
                });

                let fd = new FormData(form);
                const recaptcha = await recaptchaInit(eventName);

                fd.append("recaptcha", recaptcha);

                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );

                // let urlParams = new URLSearchParams(window.location.href);
                // let gclid_data = urlParams.get('gclid');

                // clevertap.event.push("Get a Call Back", {
                //     "Name": dataPressName.value,
                //     "Phone": dataPressPhone.value,
                //     "Gclid": gclid_data,
                //     "URL": window.location.href
                // });

                // console.log("GCLID", gclid_data);



                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    }
                });

                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {

                        if (response.status == "success") {
                            $(form).html(
                                "<div class='second-opinion-submitted pb-1 color-gray-600'>" +
                                " Thank you for submitting your details. One of our health experts will reach out to you shortly." +
                                "</div>"
                            );
                            $(form).prev().hide();

                        } else if (response.status === "error") {
                            showErrors(response.errors);

                            resetForm(form, dataPressPhone);
                        } else {
                            $(form).append(
                                "<div class='color-white text-center f-18'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                            $(form).prev().hide();

                            console.error(response);
                        }
                    })
                    .fail(function(error) {
                        console.error("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.readOnly = !p.readOnly)
                        );
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {

                let tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    });





    $("button#second-opinion-submit").on("click", async function(e) {
        e.preventDefault();

        grecaptcha.ready(async() => {
            let form = e.target.closest("form#second-opinion");
            let dataPressPhone = form.querySelector("input[data-press-phone]");
            let dataPressEmail = form.querySelector("input[data-press-email]");
            if (!(dataPressEmail.value.length > 0)) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid email!"
                });
                dataPressEmail.focus();
                dataPressEmail.classList.add("is-invalid");
                return false;
            }

            if (
                dataPressPhone.value.length < 10 ||
                dataPressPhone.value.length > 14
            ) {
                Toast.fire({
                    icon: "warning",
                    title: "Please provide a valid number!"
                });
                dataPressPhone.focus();
                dataPressPhone.classList.add("is-invalid");
                return false;
            }

            if (form.checkValidity()) {
                form.querySelectorAll("[name],button").forEach(
                    p => (p.readOnly = !p.readOnly)
                );
                if (dataPressPhone.hasAttribute("dial")) {
                    dataPressPhone.value =
                        dataPressPhone.getAttribute("dial").trim() +
                        dataPressPhone.value.trim();
                }
                let fd = new FormData($("form#second-opinion").get(0));
                fd.append("submission-url", window.location.href);
                fd.append(
                    "_token",
                    form.querySelector("input[name='_token']").value
                );

                const recaptcha = await recaptchaInit("second_opinion");

                fd.append("recaptcha", recaptcha);

                form.querySelectorAll("[name],button").forEach(
                    p => (p.disabled = !p.disabled)
                );
                $.ajaxSetup({
                    headers: {
                        "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr(
                            "content"
                        )
                    }
                });
                $.ajax({
                        url: form.getAttribute("action"),
                        type: "post",
                        data: fd,
                        cache: false,
                        contentType: false,
                        processData: false
                    })
                    .done(function(response) {
                        if (response.status == "success") {
                            $("form#second-opinion").html(
                                "<div class='second-opinion-page-submitted'>" +
                                "Thank you for the submission. We will get back to you soon." +
                                "</div>"
                            );

                            $("form#second-opinion")
                                .parent()
                                .addClass("secondOpinionMsg");
                            document
                                .querySelector(".announcement-section-panel")
                                .classList.add("secondOpinionHeight");

                            // dataLayer.push({
                            //     'event': 'Mhc_second_opinion_page_form_submit'
                            // });

                        } else if (response.status === "error") {
                            const errors = response.errors;

                            const errorsTargetEl = $(
                                "#second-opinion-page-alerts"
                            );

                            Object.keys(errors).forEach(ix => {
                                const entry = errors[ix][0];

                                errorsTargetEl.append(`

                                    <div class="alert-card">
                                        <div class="alert warning-alert">
                                            <i class="info fa fa-exclamation-circle"></i>
                                            <h3>${entry}</h3>
                                            <i class="close fa fa-times"
                                                onclick="((e) => {e.parentElement.parentElement.style.opacity = 0;setTimeout(() => {e.parentElement.parentElement.remove();}, 250);})(this);"></i>
                                        </div>
                                    </div>
                                `);

                                if (dataPressPhone.hasAttribute("dial")) {
                                    dataPressPhone.value = dataPressPhone.value
                                        .trim()
                                        .replace(
                                            dataPressPhone
                                            .getAttribute("dial")
                                            .trim(),
                                            ""
                                        );
                                }

                                form.querySelectorAll("[name],button").forEach(
                                    p => (p.readOnly = !p.readOnly)
                                );

                                form.querySelectorAll("[name],button").forEach(
                                    p => (p.disabled = !p.disabled)
                                );
                            });
                        } else {
                            $("form#second-opinion").append(
                                "<div class='text-center f-18'>" +
                                "Submission failed. Please try after sometime." +
                                "</div>"
                            );
                        }
                    })
                    .fail(function(error) {
                        console.log("error", error);
                        form.querySelectorAll("[name],button").forEach(
                            p => (p.disabled = !p.disabled)
                        );
                    });
            } else {
                var tmpSubmit = document.createElement("button");
                form.appendChild(tmpSubmit);
                tmpSubmit.click();
                form.removeChild(tmpSubmit);
            }
        });
    });
});
